/**
 * Created by rcabr on 3/23/2016.
 */

angular.module('eStories.common.directives', [

    /*Common Directives*/
])

    .directive('resizable', function ($window) {
        return function ($scope) {
            $scope.initializeWindowSize = function () {
                $scope.windowHeight = $window.innerHeight;
                $scope.windowWidth = $window.innerWidth;
            };
            $scope.initializeWindowSize();
            return angular.element($window).bind('resize', function () {
                $scope.initializeWindowSize();
                return $scope.$apply();
            });
        };
    })
    .directive('orgld', ['$filter', function ($filter) {
        return {
            restrict: 'EA',
            link: function (scope, element) {
                scope.$watch('orgLd', function (value) {
                    if (!value) {
                        return;
                    }
                    var val = $filter('json')(value);
                    element[0].innerHTML = '<script type="application/ld+json">' + val + '</script>'
                });
            }
        };
    }])
    .directive('breadcrumbsld', ['$filter', function ($filter) {
        return {
            restrict: 'EA',
            link: function (scope, element) {
                scope.$watch('breadcrumbsLd', function (value) {
                    if (!value) {
                        return;
                    }
                    var val = $filter('json')(value);
                    $('body').append('<script type="application/ld+json">' + val + '</script>');
                });
            }
        };
    }])
    .directive('siteld', ['$filter', function ($filter) {
        return {
            restrict: 'EA',
            link: function (scope, element) {
                scope.$watch('siteLd', function (value) {
                    if (!value) {
                        return;
                    }
                    var val = $filter('json')(value);
                    // TODO: should not be innerHTML bc must be on document root
                    element[0].innerHTML = '<script type="application/ld+json">' + val + '</script>'
                });
            }
        };
    }])

    .directive('countdown', [
        '$interval', function ($interval) {
            return {
                restrict: 'A',
                scope: {
                    date: '<'
                },

                link: function (scope, element) {

                    let dhms = function (t) {
                        let days, hours, minutes, seconds;
                        days = Math.floor(t / 86400);
                        t -= days * 86400;
                        if (days < 10) {
                            days = ("0" + days).slice(-2);
                        }
                        hours = Math.floor(t / 3600) % 24;
                        t -= hours * 3600;
                        if (hours < 10) {
                            hours = ("0" + hours).slice(-2);
                        }
                        minutes = Math.floor(t / 60) % 60;
                        t -= minutes * 60;
                        if (minutes < 10) {
                            minutes = ("0" + minutes).slice(-2);
                        }
                        seconds = t % 60;
                        if (seconds < 10) {
                            seconds = ("0" + seconds).slice(-2);
                        }
                        return [hours + ':', minutes + ':', seconds].join('');
                    };

                    let future;
                    future = new Date(scope.date);
                    $interval(function () {
                        let diff;
                        let now = new Date().getTime();
                        diff = Math.floor((future.getTime() - now) / 1000);
                        if (diff > 0) {
                            return element.text(dhms(diff));
                        }
                        if (diff === 0) {
                            return ['00' + ':', '00' + ':', '00'].join(' ');
                        }
                    }, 1000);
                }
            };
        }
    ]);
